import classNames from 'classnames';
import * as React from 'react';

import styles from './ComponentBox.less';

interface OwnProps {
  hasScrollbar?: boolean;
  isOverflow?: boolean;
  style?: React.CSSProperties;
}

type Props = OwnProps;

export const ComponentBox: React.FC<Props> = (props) => {
  const {children, hasScrollbar = false, isOverflow = true, ...extraProps} = props;
  return (
    <div
      className={classNames({
        [styles.dlCenterVerticalColumn]: true,
        [styles.dlScrollBarPadding]: hasScrollbar,
        [styles.dlOverflow]: isOverflow
      })}
      {...extraProps}
    >
      {children}
    </div>
  );
};

ComponentBox.displayName = 'ComponentBox';
